import {authHeaders,client,fetchImpl} from './api';
import {env} from './env';
import {api} from './api';

export type CommunicationItem={id:string;at:string;direction:'inbound'|'outbound';channel:string;official:boolean;from:string;subject:string|null;body:string;state:string;attachments:{name:string}[];source:string;request_no?:number|null};
export type CommunicationThread={id:string;audience:'customer'|'supplier'|'installer';audience_id:string;title:string;subtitle:string;latest_at:string;needs_review:boolean;waiting_reply:boolean;links:{kind:string;ref:string;label:string}[];items:CommunicationItem[]};
/** `truncated` names each source holding more than the newest `source_limit` rows the office reads (services/api communication-office.ts). */
export type CommunicationOffice={threads:CommunicationThread[];source_counts:Record<string,number>;truncated?:Record<'drafts'|'touches'|'supplier_evidence'|'installer_requests',boolean>;source_limit?:number};

export async function loadCommunicationOffice():Promise<CommunicationOffice>{
 const r=await fetchImpl(`${env.apiBase}/api/communication-office`,{headers:await authHeaders()});
 const body=await r.json() as {data?:CommunicationOffice;error?:string};
 if(!r.ok||!body.data)throw Error(body.error??'Communications Office unavailable');
 return body.data;
}

export type DraftAttachment={index:number;name:string;content_type:string;kb:number};
export async function listDraftAttachments(id:string):Promise<DraftAttachment[]>{
 const r=await fetchImpl(`${env.apiBase}/api/communications/${id}/attachments`,{headers:await authHeaders()});
 const body=await r.json() as {data?:DraftAttachment[];error?:string};
 if(!r.ok||!body.data)throw Error(body.error??'Attachments unavailable');
 return body.data;
}
/** Open one attached file in a new tab (a PDF renders in the browser). The bytes are fetched with the
 *  session, never linked bare: the API is bearer-authenticated, so a plain href would 401. */
export async function openDraftAttachment(id:string,index:number){
 const r=await fetchImpl(`${env.apiBase}/api/communications/${id}/attachments/${index}`,{headers:await authHeaders()});
 if(!r.ok)throw Error('Attachment unavailable');
 const url=URL.createObjectURL(await r.blob());window.open(url,'_blank','noopener,noreferrer');setTimeout(()=>URL.revokeObjectURL(url),60_000);
}
export function askEmma(prompt:string){window.dispatchEvent(new CustomEvent('aiw:emma-compose',{detail:{prompt}}));}

/** Send the draft the person is looking at. Their click is the human verdict (ADR-024): the backbone opens,
 *  decides and executes the one send case in a single request, so nobody is asked a second time. The key is
 *  durable, so a repeated click returns the same action. `expectedMessage` is what the screen showed; the
 *  server refuses (`stale_review`) if the draft changed underneath it. */
export async function sendShownDraft(draftId:string,expectedMessage?:Partial<{recipient:string;subject:string;body:string;mailbox:string;channel:string;delivery:string}>){
 return api.propose(client,{command:'send_communication',args:{draft_id:draftId,...(expectedMessage?{expected_message:expectedMessage}:{})},idempotency_key:`communication-send:${draftId}`,verdict:{decision:'approve'}});
}
